/** @jsx jsx */

import * as React from "react";
import { css, jsx } from "@emotion/core";
import { DESIGN_TOKEN } from "Config/design_token";

type Props = React.PropsWithChildren<{}>;

function SplashLayout(props: Props): JSX.Element {
  return (
    <main
      css={css`
        display: flex;
        width: 100%;
        height: 100vh;
        background-color: ${DESIGN_TOKEN.colors.swatch_5};
      `}
    >
      {props.children}
    </main>
  );
}

const splashLayoutMemo = React.memo<Props>(SplashLayout);

export { splashLayoutMemo as SplashLayout };
